import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({ name: 'imgCompressed', pure: true })

// Pipe for switching to compressed path - replacing extension type to .webp format
export class ImageCompressedPipe implements PipeTransform {
  extensionRegex: RegExp = /(\.jpeg|\.jpg|\.png)$/i;
  constructor() {}

  /**
   * @param url: Replace the url to new compressed path
   */
  transform(url: string): string {
    if (!url) return url;

    // If the URL already contains '/dashboard/compressed/', we don't replace '/dashboard/' again
    if (!url.includes('/compressed/')) {
      url = url.replace('/dashboard/', '/dashboard/compressed/');
    }

    // Replace spaces with '+', '/private/' with '/private/compressed/', and image extensions with '.webp'
    return url
      .replace(/ /g, '+')
      .replace('/private/', '/private/compressed/')
      .replace(this.extensionRegex, '.webp');
  }
}
